import { UPDATE_FIELD, RESET_FORM } from './types';

export const updateField = field => ({
  type: UPDATE_FIELD,
  payload: field
});

export const resetForm = () => ({
  type: RESET_FORM
});



// WEBPACK FOOTER //
// ./src/store/ContactForm/actions.js